<template>
  <div class="community-inline-list">
    <div
      v-for="community in communities"
      :key="community.title"
      class="community-inline-list__item"
    >
      <BasicButton
        appearance="badge"
        :href="community.href"
        target="_blank"
      >
        <InlineAlign gap="small">
          <template #start>
            <SvgIcon
              :source="$options.source"
              :icon="`service-${community.icon}`"
              size="16"
            />
          </template>
          <template #default>
            <span v-text="community.title" />
          </template>
        </InlineAlign>
      </BasicButton>
    </div>
  </div>
</template>

<script>
  import BasicButton from 'src/components/BasicButton/BasicButton.vue';
  import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';
  import InlineAlign from 'src/components/InlineAlign/InlineAlign.vue';

  export default {
    name: 'CommunityInlineList',
    components: { SvgIcon, InlineAlign, BasicButton },
    source: '/images/services.svg',
    props: {
      communities: {
        type: Array,
        required: true,
      }
    }
  }
</script>